import { CustomerName } from 'app/components/customer/CustomerInfo'
import {FC} from 'react'

type Props = {
  address: any
  title: string
}

const Address: FC<Props> = ({address, title}) => {
  if (!address) {
    return null
  }
  return (
    <>
      <div className='fw-bold fs-7 text-gray-600 '>{title}</div>
      <div className='fw-bolder fs-6 text-gray-800'>
      <CustomerName firstName={address.firstName} lastName={address.lastName} />
      </div>
      <div className='fw-bold fs-7 text-gray-600'>
        {address.addressLine1}
        <br />
        {address.addressLine2 && (
          <>
            {address.addressLine2}
            <br />
          </>
        )}
        {address.city}, {address.state.code} {address.zipCode}
      </div>
    </>
  )
}

export default Address
